import { HomeOutlined, PersonOutlined } from "@material-ui/icons";
import { defaultPipelines } from "../pipeline-center/pipeline-center-helpers";
import { routes } from "./routes";
const getCurrentVisible = value => (value?.visibleInNav !== undefined ? value?.visibleInNav : true);

const generateDefaultRoute = (info, pipelineCenter) => {
    if (info.subcategories?.length > 0) {
        const isShownSubcategories = info.subcategories?.filter(p => getCurrentVisible(pipelineCenter?.[p.pipeline]));
        if (isShownSubcategories?.length > 0) {
            return {
                name: info.pipelineTitle,
                collapse: true,
                state: info.pipelineTitle,
                multiStates: ["Pipelines"],
                inner: info.inner,
                views: isShownSubcategories?.map(subcategory => ({
                    name: subcategory.pipelineTitle,
                    path: `/pipelines${subcategory.route}`,
                    inner: subcategory.inner,
                    info: subcategory.info,
                    icon: subcategory?.relatedTo === "contact" ? <PersonOutlined /> : <HomeOutlined />
                }))
            };
        }
    } else {
        return {
            name: info.pipelineTitle,
            path: `/pipelines${info.route}`,
            inner: info.inner,
            info: info.info,
            icon: info?.relatedTo === "contact" ? <PersonOutlined /> : <HomeOutlined />
        };
    }
};

const generatePipelineRoute = info => {
    if (info.subcategories?.length > 0) {
        const isShownSubcategories = info.subcategories?.filter(el => el.isShown || el.isShown === undefined);
        if (isShownSubcategories?.length > 0) {
            return {
                name: info.pipelineTitle,
                collapse: true,
                state: info.pipelineTitle,
                multiStates: ["Pipelines"],
                inner: info.inner,
                views: isShownSubcategories?.map(subcategory => ({
                    name: subcategory.pipelineTitle,
                    path: `/pipelines${subcategory.route}`,
                    inner: subcategory.inner,
                    info: subcategory.info,
                    icon: subcategory?.relatedTo === "contact" ? <PersonOutlined /> : <HomeOutlined />
                }))
            };
        }
    } else {
        return {
            name: info.pipelineTitle,
            path: `/pipelines${info.route}`,
            inner: info.inner,
            info: info.info,
            icon: info?.relatedTo === "contact" ? <PersonOutlined /> : <HomeOutlined />
        };
    }
};

export function isFormBooked(workspace, id) {
    const landingPages = workspace?.contents?.landingPages;
    return landingPages?.[id]?.booked;
}

export function getFilteredDefaultPipelines(workspace) {
    const isTippgeberPipelineBooked = isFormBooked(workspace, "lp_100009");
    const useStandardIMVPipeline = workspace?.adminUser?.imv?.useStandardPipeline;
    return defaultPipelines.map(pipeline => {
        if (pipeline.hasSub && pipeline.subcategories) {
            let subcategories = pipeline.subcategories;

            if (!useStandardIMVPipeline) {
                subcategories = subcategories.filter(subcategory => subcategory.pipeline !== "imv");
            }

            subcategories = subcategories.filter(subcategory =>
                isTippgeberPipelineBooked ? subcategory.pipeline !== "partnership" : subcategory.pipeline !== "tipper-leads"
            );

            return { ...pipeline, subcategories };
        }

        return pipeline;
    });
}

export const generateDefaultPipelineRoutes = workspace => {
    // const showContentPipeline = isContentBooked(workspace);
    // const defaultBookedPipelines = showContentPipeline ? defaultPipelines : defaultPipelines.filter(item => item.pipeline !== "marketing-content");
    const filteredDefaultPipelines = getFilteredDefaultPipelines(workspace);

    const showWunschImmoPipeline = isFormBooked(workspace, "lp_100007");
    const defaultBookedPipelines = showWunschImmoPipeline
        ? filteredDefaultPipelines
        : filteredDefaultPipelines.filter(item => item.pipeline !== "prospective-buyer");
    const defaultViews = defaultBookedPipelines.filter(p => !p.noAccessForNewAccounts);

    const newDefaultPipelines = workspace?.integrations?.leadConnect?.vrBank?.isPartner
        ? defaultViews
        : defaultViews?.filter(item => item?.pipeline !== "vr-bank-partners");
    return newDefaultPipelines

        .map(pipeline => {
            return generatePipelineRoute(pipeline);
        })
        .filter(pipeline => pipeline !== undefined);
};

export const generateRoutesList = ({ customPipelines, pipelineCenter, accessSalesPipelineSub, workspace }) => {
    // const showWunschImmoPipeline = isWunschimmoBooked(workspace);
    // const defaultBookedPipelines = showWunschImmoPipeline ? defaultPipelines : defaultPipelines.filter(item => item.pipeline !== "prospective-buyer");

    return routes(workspace).map(route => {
        if (route.name === "Pipelines") {
            const filteredDefaultPipelines = getFilteredDefaultPipelines(workspace);
            const defaultPipelinesViews = filteredDefaultPipelines.filter(p => (p.noAccessForNewAccounts ? accessSalesPipelineSub : true));

            const newDefaultPipelines = workspace?.integrations?.leadConnect?.vrBank?.isPartner
                ? defaultPipelinesViews
                : defaultPipelinesViews?.filter(item => item?.pipeline !== "vr-bank-partners");

            const defaultViews = newDefaultPipelines
                .filter(p => getCurrentVisible(pipelineCenter?.[p.pipeline]))
                .map(pipeline => {
                    return generateDefaultRoute(pipeline, pipelineCenter);
                })
                .filter(pipeline => pipeline !== undefined);
            const customViews = customPipelines
                .filter(p => (p.isShown !== undefined ? p.isShown : true))
                .map(pipeline => {
                    return generatePipelineRoute(pipeline);
                })
                .filter(pipeline => pipeline !== undefined);

            return {
                ...route,
                views: [...defaultViews, ...customViews]
            };
        } else return route;
    });
};
